@if (crmBannerPromotions.length) {
    <ms-crm-promotion-container [promotions]="crmBannerPromotions" />
}

@if (!isEmpty) {
    <section class="horses-race-section">
        <header class="main-header">
            <div class="race-info-top">
                @if (fixture.startDate) {
                    <span class="meeting-time">{{ fixture.startDate | date: 'HH:mm' }} </span>
                }
                @if (fixture.meeting) {
                    <span class="meeting-name">{{ fixture.meeting.name | msTranslate }}</span>
                }
                <div class="runners-mobile">
                    <span class="runners-count">{{ runners }} {{ sitecore.horseRacing.nextThreeRaces.Runners }}</span>
                    @if (fixture.timeform?.going) {
                        <span>, {{ fixture.timeform?.going }}</span>
                    }
                </div>
                @if (!isResulted) {
                    <div class="race-timer">
                        @if (isRaceOff) {
                            <vn-icon name="sports-greyhounds-race-off" size="16" class="race-off-icon" />
                        }
                        @if (fixture.addons.raceSummary) {
                            <span class="race-status">{{ updateStatus(fixture) }}</span>
                        } @else {
                            @if (display && timeInSeconds > 0) {
                                <span class="race-starts-in-text">{{ sitecore.horseRacing.nextThreeRaces!.StartsIn }} </span>
                            }
                            <ms-countdown-timer
                                [timeInSeconds]="timeInSeconds"
                                [textAfterTimerFinished]="sitecore.horseRacing.raceSummary!.PostTime"
                                [isSports]="true"
                                (display)="onDisplay($event)" />
                        }
                    </div>
                }
                @if (isResulted) {
                    <ms-horses-race-badges [resulted]="isResulted" />
                }
            </div>
            <div class="race-info-bottom">
                <ms-fixture-market-title msTextAutoScroll class="race-name" [marqueeAutoScroll]="true" [fixture]="fixture" [isHorseRace]="true" />
                @if (fixture.addons.rule4Expected) {
                    <ms-horses-race-badges class="rule4" [rule4Expected]="fixture.addons.rule4Expected" />
                }
                <ms-race-view-best-odds-badge [fixture]="fixture" />
                <div class="runners">
                    <span class="runners-count">{{ runners }} {{ sitecore.horseRacing.nextThreeRaces.Runners }}</span>
                    @if (fixture.timeform?.going) {
                        <span msTextAutoScroll [marqueeAutoScroll]="true">, {{ fixture.timeform?.going }}</span>
                    }
                </div>
            </div>
        </header>
    </section>
}

@if (!isEmpty) {
    <section [ngClass]="!isResulted ? 'horses-race-details race-details-section' : 'horses-race-details'">
        @if (!fixture.isOptionBet && !isResulted) {
            <ms-horses-race [fixture]="fixture" />
        }
        @if (fixture.isOptionBet && !isResulted) {
            <ms-horses-derived-race [fixture]="fixture" />
        }
        @if (isResulted) {
            <ms-horses-race-resulted [fixture]="fixture" />
        }
    </section>
}

@if (!fixture) {
    <ms-error [links]="false" [message]="sitecore.fixture.common.ErrorNoFixture" [severity]="'info'" />
}
